import "./counter.css.ts.vanilla.mjs";
var t = "p273__counter-2c97_fdfd26d__1jkpl8f0";
export {
  t as counterStyle
};
//# sourceMappingURL=counter.mjs.map
